import { SignupRequestError } from './signup-api/signup-api';

/**
 * Verify refused the code because the contact is already on another member's
 * profile. Signing in with that contact would make a second account, so the
 * member is sent to the login page to use the contact they joined with.
 */
export function isContactOnAnotherAccount(error: unknown): boolean {
  return error instanceof SignupRequestError && error.code === 'contact_on_another_account';
}
